import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/sky-logo.jpg"
          width="auto"
          height="100%"
          loading="lazy"
          alt="Siddha SkyWadala"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Siddha | Sejal Realty is a collaboration between two renowned names in
        Indian real estate, united by a shared vision to transform Mumbai’s
        skyline with design-driven, future-ready developments.
        <p>
          Siddha Group, with a legacy spanning over three decades, has been
          creating high-quality residential and commercial spaces across Mumbai,
          Kolkata, and Jaipur. Known for blending affordability with elegance,
          Siddha has pioneered innovations like India’s first Rooftop Skywalks
          and has earned 30+ prestigious awards over its 39-year journey.
        </p>
        <p>
          Sejal Realty brings deep expertise in urban redevelopment, with a
          focus on society and SRA projects that aim to conserve and enhance
          Mumbai’s built and natural heritage. Guided by visionary leadership
          and a team of passionate professionals, Sejal Realty is committed to
          delivering excellence with integrity.
        </p>
        <p>
          Together, SiDDHA | SEJAL Realty is crafting a new benchmark in
          contemporary living with Siddha Sky, Wadala — a landmark project that
          embodies luxury, innovation, and urban elevation.
        </p>
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/rera-P51900021027.jpg" alt="rera qr" />
          <strong>P51900021027</strong>
        </div>

        <div class="rera-item">
          <img src="images/rera-P51900021040.jpg" alt="rera qr" />
          <strong>P51900021040</strong>
        </div>

        <div class="rera-item">
          <img src="images/rera-P51900021044.jpg" alt="rera qr" />
          <strong>P51900021044</strong>
        </div>

        <div class="rera-item">
          <img src="images/rera-P51900021031.jpg" alt="rera qr" />
          <strong>P51900021031</strong>
        </div>

        <div class="rera-item">
          <img src="images/rera-P51900055793.jpg" alt="rera qr" />
          <strong>P51900055793</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
